import store from "../store";
import globalNewCar from "./globalNewCar";

export default function (imgName, size) {
    return globalNewCar.getPicUrl(imgName);
    // size = size || 'thumbnail';
    // let url = store.state.baseUrl;
    // let expansion = 'jpg';
    //
    // var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    //
    // if (!!window.chrome || isFirefox) {
    //     expansion = 'webp';
    // }
    //
    // url += '/img/blog/i/'
    // return url + size + "_" + imgName + "." + expansion;

}